import { SectionTagTypeEnum, SectionTypeEnum } from 'common/enums/AfterSales'
import { RedemptionStatusEnum } from 'common/enums/RedemptionStatusEnum'
import { AvailableTicketsSection } from 'components/AvailableTicketSection/AvailableTicketsSection'
import { TicketSection } from 'components/TicketSection/TicketSection'
import { useSortCompletedSentRedemption } from 'hooks/useSortCompletedSentRedemption'
import { ITicketsInfo } from 'store/afterSales/types'

import { Alert } from '@interco/inter-ui/components/Alert'

import { SectionAccordion } from './SectionAccordion/SectionAccordion'
import { AnalyticsTicketFlow } from '../AfterSales.tags'

export const MyTicketsAccordionManager = ({ tickets }: { tickets: ITicketsInfo }) => {
  const {
    available = [],
    active = [],
    completed = [],
    processing = 0,
    paymentProcessing = 0,
    totalRedemptionAmount = 0,
  } = tickets

  const hasAvailableProcessingTickets =
    available.length > 0 || processing > 0 || paymentProcessing > 0

  const hasActiveTickets = active.length > 0
  const hasCompletedTickets = completed.length > 0
  const sortedCompletedTickets = useSortCompletedSentRedemption({ tickets: completed })

  const hasTicketRedemption = totalRedemptionAmount > 0

  const hasSentToRedemptionTicket = sortedCompletedTickets.sortedTickets.some(
    (ticket) => ticket.redemptionStatus === RedemptionStatusEnum.SENT_TO_REDEMPTION,
  )

  const renderAvailableSection = () =>
    hasAvailableProcessingTickets && (
      <SectionAccordion
        title={SectionTypeEnum.AVAILABLE}
        content={
          <AvailableTicketsSection
            availableTickets={available}
            processingTickets={processing}
            paymentProcessingTickets={paymentProcessing}
            analyticsFunction={() =>
              AnalyticsTicketFlow(SectionTagTypeEnum.AVAILABLE, '-', '-', '')
            }
          />
        }
      />
    )

  const renderActiveSection = () =>
    hasActiveTickets && (
      <SectionAccordion
        title={SectionTypeEnum.ACTIVE}
        content={
          <TicketSection
            ticketsList={active}
            sectionTag={SectionTagTypeEnum.ACTIVE}
            sectionTitle={SectionTypeEnum.ACTIVE}
          />
        }
      />
    )

  const renderCompletedSection = () =>
    hasCompletedTickets && (
      <>
        {hasSentToRedemptionTicket && (
          <Alert type="warning">
            Fique tranquilo, estamos processando o pagamento do resgate, o valor será
            disponibilizado em breve.
          </Alert>
        )}
        <SectionAccordion
          title={SectionTypeEnum.COMPLETED}
          content={
            <TicketSection
              ticketsList={sortedCompletedTickets.sortedTickets}
              sectionTag={SectionTagTypeEnum.COMPLETED}
              sectionTitle={SectionTypeEnum.COMPLETED}
            />
          }
        />
      </>
    )

  return (
    <>
      {renderAvailableSection()}

      {hasTicketRedemption || hasSentToRedemptionTicket ? (
        <>
          {renderCompletedSection()}
          {renderActiveSection()}
        </>
      ) : (
        <>
          {renderActiveSection()}
          {renderCompletedSection()}
        </>
      )}
    </>
  )
}
